const numericSortKeys = new Set(["need", "optimizing", "importance"]);

document.querySelectorAll<HTMLTableElement>("[data-sortable-table]").forEach((table) => {
  const body = table.tBodies[0];
  if (!body) return;

  table.querySelectorAll<HTMLButtonElement>("[data-sort-key]").forEach((button) => {
    button.addEventListener("click", () => {
      const key = button.dataset.sortKey;
      if (!key) return;

      const header = button.closest("th");
      const currentlyAscending = header?.getAttribute("aria-sort") === "ascending";
      const direction = currentlyAscending ? "descending" : "ascending";
      const multiplier = direction === "ascending" ? 1 : -1;

      const rows = Array.from(body.rows);
      rows.sort((left, right) => {
        const leftValue = left.dataset[key] || "";
        const rightValue = right.dataset[key] || "";

        if (numericSortKeys.has(key)) {
          return (Number(leftValue) - Number(rightValue)) * multiplier;
        }

        return leftValue.localeCompare(rightValue, undefined, { numeric: true }) * multiplier;
      });

      table.querySelectorAll("th[aria-sort]").forEach((column) => column.setAttribute("aria-sort", "none"));
      header?.setAttribute("aria-sort", direction);
      rows.forEach((row) => body.appendChild(row));
    });
  });
});
